import { Popup, PopupContent, PopupHeader, PopupProps, Typography } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { RecentQuotesList } from './RecentQuotesList'

interface RecentQuotesPopupProps extends Pick<PopupProps, 'open' | 'anchorEl'> {
  onClose: () => void
}

export const RecentQuotesPopup: FC<RecentQuotesPopupProps> = ({ open, anchorEl, onClose, ...props }) => {
  const { translate } = useI18n()

  return (
    <Popup
      open={open}
      anchorEl={anchorEl}
      onClickAway={onClose}
      width={600}
      height={320}
      placement="right-start"
      {...props}
    >
      <PopupHeader>
        <Typography color="textSecondary">{translate('sidebar-new_quote-recent_quotes')}</Typography>
      </PopupHeader>
      <PopupContent>
        <RecentQuotesList onClickItem={onClose} />
      </PopupContent>
    </Popup>
  )
}
